import { render } from "./PaginationTwo.vue?vue&type=template&id=0557aca2&ts=true"
import script from "./PaginationTwo.vue?vue&type=script&lang=ts"
export * from "./PaginationTwo.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__